module.exports = __webpack_public_path__ + "img/tuiguang.fce31951.png";